<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>仓储管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 商品信息表格 -->
      <el-table id="pdfDom" :data="storageNumberList">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="产品类型" prop="TypeName" align="center"></el-table-column>
        <el-table-column label="总库存数量" prop="num" align="center"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '5',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            getTypeList1: {
                page: '1',
                limit: '100',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            total: 0,
            storageNumberList: []
        }
    },
    created () {
        this.getStorageNumber()
        this.getStorageNumber1()
    },
    mounted () {
        this.timer2 = setInterval(() => {
            this.getStorageNumber()
        }, 2000);
        this.$once('hook:beforeDestroy', () => {
            clearInterval(timer2);
        })
    },
    beforeDestroy () {
        clearInterval(this.timer2);
        this.timer2 = null;
    },
    methods: {
        //调用接口获取仓库储位信息
        async getStorageNumber () {
            const { data: res } = await this.$http.get('/WMS/queryTypeSum', { params: this.getTypeList })
            console.log(res.data)
            this.storageNumberList = res.data
        },
        async getStorageNumber1 () {
            //const { data: res } = this.$http.get(`/queryStorageLocation/${params}`)
            //const { data: res } = this.$http.get(`/queryStorageLocation/${this.page}/${this.limit}/${this.privateKey}/${this.appIdentification}`)
            const { data: res } = await this.$http.get('/WMS/queryTypeSum', { params: this.getTypeList1 })
            console.log(res)
            this.total = res.data.length
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getStorageNumber()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.getTypeList.page = newPage
            this.getStorageNumber()
        },
        getpdfyes () {
            this.getPdf()
        }
    }
}
</script>

<style lang="less" scoped>
.download {
  position: absolute;
  left: 94%;
  top: 12%;
  transform: translate(50%, 50%);
}
</style>
